export const MEDIUM_BLOGS_LINK = "https://medium.com/robotics-club-sastra/";
export const FB_BLOGS_LINK = "https://www.facebook.com/roboticsclubsastra/";
export const GMAIL_LINK = "mailto:rcsatsastra@gmail.com?subject=Hey%20RCS!";
export const IG_LINK = "https://www.instagram.com/robotics_club_sastra/";

export const LOCAL_BASE_URL = "http://localhost:5000/v1/";

export const PROD_BASE_URL = "https://rcs-flask-app.herokuapp.com/v1/";

export const SERVER_BASE_URL = PROD_BASE_URL;

export const SERVER_ROUTES = {
    "login":  "members/login",
    "adminLogin": "admin/login",
    "createUser": "members/create",
    "teamDetailsByYear": "membersList/members/",
    "membersIn": "membersList/members/in",
    "memberDataFetchById": "dashboard/member/",
    "memberDataUpdate": "dashboard/memberData/update",
    "uploadCsvForMultipleOnboard": "admin/uploadCsvForMultipleOnboard",
    "createProject": "projects/create",
    "updateProject": "projects/update",
    "getProjectsByMemberId": "projects/get/",
    "getAllProjects": "projects/all",
    "get5Projects": "projects/5/",
    "getRandomProjects": "projects/random/",
    "sendInvite": "admin/sendInvite"
}
